import { io } from "socket.io-client";

export const socket = io("https://realtime-chat-platform-jfh0.onrender.com");
